import { isRef, unref } from 'vue';
import { Compliance, ActionCodeEnum } from './compliance';
import { useMessage } from "/@/hooks/web/useMessage";

const { createConfirm, createMessage } = useMessage()

export const complianceRule = {
  mounted(el, binding) {
    const { value, arg } = binding

    const options = {
      event: arg || 'click',
    }

    const { handler: fn, params: { business, sceneCode, cdata } } = value

    const compliance = Compliance({ business, sceneCode })
    const handler = async () => {
      // 获取场景参数
      const scene = compliance.scenes.find(s => s.code == sceneCode)
      if(!scene) {
        return fn()
      }

      const resolvedParams = isRef(cdata) ? unref(cdata) : cdata
      let params = {}
      scene.params.forEach(p => {
        params[p.code] = resolvedParams[p.code]
      })
      
      const res = await compliance.execute({ sceneCode, params })
      const warn = res.find(d => d.actionCode == ActionCodeEnum.WarnPrompt),
        reject = res.find(d => d.actionCode == ActionCodeEnum.RejectSubmit)
      
      // 拦截流程
      if(reject) {
        createMessage.warning(reject.ruleMsg)
        return
      }
      // 预警提示
      if(warn) {
        createConfirm({
          iconType: 'warning',
          title: '确认',
          content: warn.ruleMsg,
          onOk: () => fn,
          onCancel: () => {},
        })
      }
    }

    el.addEventListener(options.event, handler)

    el.__ruleHandler = handler
    el.__ruleEvent = options.event
  },

  //清理注册事件，避免后续页面再次绑定
  unmounted(el) {
    if(!el.__ruleHandler) return

    el.removeEventListener(el.__ruleEvent, el.__ruleHandler)
    delete el.__ruleHandler
    delete el.__ruleEvent
  }
} 